// Single-line text intake normalization (T-200). Two prod rows broke
// downstream matching because of characters no one could see: a vendor name
// pasted with U+00A0 no-break spaces instead of spaces (QuickBooks display-name
// match failed) and a product_service that carried a U+FFFD replacement char
// from a mis-decoded backfill CSV (garbage in the billing output). Every
// name-ish field on every intake path runs through cleanText() before its
// length/format rules, so what's stored is what a person would have typed.
//
// Character classes are written as \u escapes on purpose: the whole point is
// that these bytes are invisible in an editor.

// Unicode space separators that should simply be a space.
const UNICODE_SPACES = /[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g;
// Zero-width characters, the BOM, and the replacement char — never meaningful
// in a name; U+FFFD is already-lost data, so dropping it is the only fix.
const INVISIBLES = /[\u200B-\u200D\u2060\uFEFF\uFFFD]/g;
// C0/C1 control characters, minus tab/newline/CR (folded to a space below).
// C1 (U+0080–U+009F) is what a cp1252 byte looks like after a latin1 decode.
// eslint-disable-next-line no-control-regex -- matching control chars is the point
const CONTROLS =/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g;

/**
 * Normalize a single-line human-entered string: NFC, Unicode spaces → ASCII
 * space, zero-width/BOM/U+FFFD/control chars removed, tabs/newlines folded to
 * a space, runs of spaces collapsed, ends trimmed. Legitimate non-ASCII
 * (accents, curly quotes, dashes) is preserved. Idempotent.
 */
export function cleanText(s: string): string {
  return s
    .normalize('NFC')
    .replace(UNICODE_SPACES, ' ')
    .replace(INVISIBLES, '')
    .replace(CONTROLS, '')
    .replace(/[\t\n\r]+/g, ' ')
    .replace(/ {2,}/g, ' ')
    .trim();
}
